import React, { useContext, FC } from 'react';
import { graphql, useStaticQuery } from 'gatsby';
import Helmet from 'react-helmet';
import { Redirect, Router } from '@reach/router';
import ROUTES from '../../routes';
import { useTranslation } from '../../hooks/useTranslation';
import { featureFlagsContext } from '../../providers/FeatureFlagsProvider';
import Backdrop from '../../components/backdrop';
import { OutageMapNotificationContextProvider } from '../../providers/OutageMapNotificationProvider';
import useContactDataInterceptModal from '../../hooks/useContactDataInterceptModal';
import ContactDataInterceptModal from '../../components/contact-data-intercept-modal';
import { OutagesPage } from '../../components/outage_v2/Outages';
import NotFoundPage from '../404';
import { DEFAULT_LANGUAGE, LanguageContext } from '../../providers/LanguageProvider';

const Outages: FC = () => {
  const { t } = useTranslation();
  const { loading, contactDataIntercept } = useContext(featureFlagsContext);
  const { language } = useContext(LanguageContext);
  const {
    open,
    contactData,
    setOpen,
    setIsSessionDismissed,
  } = useContactDataInterceptModal(contactDataIntercept);

  const data = useStaticQuery(graphql`
    query allContentfulApplicationPage {
      allContentfulApplicationPage(filter: {contentful_id: {eq: "7DofE2F79s5h7nHzzNG86W"}}) {
        nodes{
          pageTitle
          metaDescription
          node_locale
        }
      }
    }
  `);

  const outagePage =
    data.allContentfulApplicationPage.nodes.find((n: { node_locale: string }) => n.node_locale === language)
    || data.allContentfulApplicationPage.nodes.find((n: { node_locale: string }) => n.node_locale === DEFAULT_LANGUAGE)
    || data.allContentfulApplicationPage.nodes[0];
  const { metaDescription, pageTitle } = outagePage;

  return (
    <>
      <Helmet bodyAttributes={{ class: 'TemplatePage' }}>
        <title>{pageTitle}</title>
        <meta name="description" content={metaDescription} />
      </Helmet>
      <style type="text/css">
        {`
      .MuiAlert-root {
        margin: 2px;
        border-radius: 0
      }
    `}
      </style>
      {loading ? (
        <Backdrop forceOpen />
      ) : (
        <>
          <Router basepath={ROUTES.OUTAGES}>
            <OutagesPage path="/" />
            <NotFoundPage path="/*" />
          </Router>

          {open && (
            <ContactDataInterceptModal
              open={open}
              onClose={() => setOpen(false)}
              contactData={contactData}
              setIsSessionDismissed={setIsSessionDismissed}
            />
          )}
        </>
      )}
    </>
  );
};

export default Outages;
